<div *ngIf="filterVisibilitySettings.isShowFilterHeader">
    <span><ds-icon name="filter_alt" size="md" class="mr-3"></ds-icon><b>Filter Options</b></span>
    <span *ngIf="!isCustomer" class="float-right text-danger btn" (click)="toggleMoreFilter()">
        <b>More Filters <ds-icon id="moreFilterIcon" name="expand_more" size="inherit" class="ml-3 js-expand-icon"></ds-icon></b>
    </span>
    <ng-container>
        <span
            id="saveFilter"
            class="mr-2 float-right cursorPointer saveFilterOption px-2 py-1"
            data-target="#userPreferenceSetting"
            data-toggle="modal"
            name="saveFilter"
            title="Manage member preference settings"
            (click)="isShowMemberPreferenceSettingPopup = !isShowMemberPreferenceSettingPopup"
        >
            <ds-icon name="settings" size="md" aria-hidden="true"></ds-icon>
        </span>
    </ng-container>
</div>
<hr *ngIf="filterVisibilitySettings.isShowFilterHeader" class="hr-class my-4" />
<div class="row">
    <div *ngIf="filterVisibilitySettings.serviceTypeDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Service Type</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    [settings]="dropDownSettings.ServiceDropdownSettings"
                    [data]="filterDropdownData.serviceTypeList"
                    [placeholder]="'Service Type'"
                    [(ngModel)]="filterDropdownData.selectedServiceTypeList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.legStatusDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <!-- This dropdown is for leg Status -->
            <label *ngIf="filterVisibilitySettings.isShowLable">Status</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    [settings]="dropDownSettings.StatusDropdownSettings"
                    [data]="filterDropdownData.legStatusList"
                    [placeholder]="'Status'"
                    [(ngModel)]="filterDropdownData.selectedLegStatusList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.srStatusDropDown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <!-- This dropdown is for Service Request Status -->
            <label *ngIf="filterVisibilitySettings.isShowLable">Status</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    [settings]="dropDownSettings.StatusDropdownSettings"
                    [data]="filterDropdownData.srStatusList"
                    [placeholder]="'Status'"
                    [(ngModel)]="filterDropdownData.selectedSrStatusList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.unosDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">UNOS ID</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    id="unosIdListDropdown"
                    [settings]="dropDownSettings.CommonDropdownSettings"
                    [data]="filterDropdownData.unosList"
                    [placeholder]="'UNOS ID'"
                    [(ngModel)]="filterDropdownData.selectedUnosList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.tripIdDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Trip ID</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    id="tripIdListDropdown"
                    [settings]="dropDownSettings.CommonDropdownSettings"
                    [data]="filterDropdownData.tripIdList"
                    [placeholder]="'TripID'"
                    [(ngModel)]="filterDropdownData.selectedTripIdList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.tissueIdDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <div>
                <label>Tissue ID</label>
                <div class="select-box">
                    <ng-multiselect-dropdown-angular7
                        [settings]="dropDownSettings.TissueIdDropdown"
                        [data]="filterDropdownData.tissueIdList"
                        [placeholder]="'TissueID'"
                        [(ngModel)]="filterDropdownData.selectedTissueIdList"
                        (ngModelChange)="applyFilterIfAplicable()"
                    >
                    </ng-multiselect-dropdown-angular7>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.customerDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Customer </label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    [settings]="dropDownSettings.CustomerDropdownSettings"
                    [data]="filterDropdownData.customerList"
                    [placeholder]="'Customer'"
                    [(ngModel)]="filterDropdownData.selectedCustomerList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.originLocationDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Origin</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    placeholder="Origin"
                    [settings]="dropDownSettings.LocationDropdownSettings"
                    [data]="filterDropdownData.originLocationList"
                    [(ngModel)]="filterDropdownData.selectedOriginLocationList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.destinationLocationDropdown" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">Destination</label>
            <div class="select-box">
                <ng-multiselect-dropdown-angular7
                    placeholder="Destination"
                    [settings]="dropDownSettings.LocationDropdownSettings"
                    [data]="filterDropdownData.destinationLocationList"
                    [(ngModel)]="filterDropdownData.selectedDestinationLocationList"
                    (ngModelChange)="applyFilterIfAplicable()"
                >
                </ng-multiselect-dropdown-angular7>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.fromDate" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="cursorPointer filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">From Date</label>
            <button
                id="fromDateClear"
                class="plus-icon mt-0"
                name="clearFromDate"
                title="Clear From Date"
                type="button"
                (click)="clearDate('from')"
            >
                <ds-icon name="cancel" size="inherit"></ds-icon>
            </button>
            <div id="fromdate" class="fromDate cursorPointer" (click)="openDatePicker('fromDate')">
                <input
                    id="from"
                    class="form-control fromDate"
                    #fromDate="ngModel"
                    autocomplete="off"
                    name="fromdate"
                    type="text"
                    [(ngModel)]="filterDropdownData.fromDate"
                    (ngModelChange)="applyFilterIfAplicable()"
                />
                <ds-icon name="calendar_today" size="inherit" class="calendar-icon"></ds-icon>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.toDate" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="cursorPointer filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable">To Date</label>
            <button
                id="toDateClear"
                class="plus-icon mt-0"
                name="clearToDate"
                title="Clear To Date"
                type="button"
                (click)="clearDate('to')"
            >
                <ds-icon name="cancel" size="inherit"></ds-icon>
            </button>
            <div id="todate" class="toDate cursorPointer" (click)="openDatePicker('toDate')">
                <input
                    id="to"
                    class="form-control toDate"
                    #toDate="ngModel"
                    autocomplete="off"
                    name="todate"
                    type="text"
                    [(ngModel)]="filterDropdownData.toDate"
                    (ngModelChange)="applyFilterIfAplicable()"
                />
                <ds-icon name="calendar_today" size="inherit" class="calendar-icon"></ds-icon>
            </div>
        </div>
    </div>
    <div *ngIf="filterVisibilitySettings.isActionButtonVisible" class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div class="cursorPointer filter-option-div mb-3">
            <label *ngIf="filterVisibilitySettings.isShowLable" class="mb-2 pb-1 visibility-hidden">Dummy Label</label>
            <div class="select-box">
                <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn px-4" type="button" (click)="applyFilter()">
                    Apply
                </button>
                <button
                    class="flat-butt flat-info-butt flat-info-grad-butt flat-danger-butt ml-4 px-3"
                    type="button"
                    (click)="clearFilter()"
                >
                    Clear
                </button>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isShowMemberPreferenceSettingPopup">
    <app-member-preference-model
        [customerList]="filterDropdownData.customerList"
        [customerListSetting]="dropDownSettings.CustomerDropdownSettings"
        [dateFilters]="dateFilters"
        [dropdownSettings]="dropDownSettings.ServiceDropdownSettings"
        [financialStatusSetting]="dropDownSettings.FinancialStatusSettings"
        [memberPreferenceSettings]="memberPreferenceSetting"
        [originSetting]="dropDownSettings.LocationDropdownSettings"
        [regionDropdownSettings]="dropDownSettings.RegionDropdownSettings"
        [regionList]="regionList"
        [serviceOriginLocations]="filterDropdownData.originLocationList"
        [serviceTypes]="filterDropdownData.serviceTypeList"
        [statusDropdownSettings]="dropDownSettings.StatusDropdownSettings"
        [statusList]="filterDropdownData.srStatusList"
        [timezoneConfig]="dropDownSettings.TimeZoneConfig"
        [timeZoneList]="filterDropdownData.timeZoneList"
        (closeMemberPreferenceSettingPopup)="closeMemberPreferenceSettingPopup()"
        (saveMemberPreferenceSettings)="saveMemberPreferenceSettings($event)"
    >
    </app-member-preference-model>
</ng-container>
